import apiFetch from '../../apiFetch'

export default function (token, dossierId) {
  return apiFetch({ endPoint: `dossier/purchase/${dossierId}/header`, method: 'GET', body: null, token: token })
}
